import { OpaccFavorite } from './classes/opacc.class.favorite.js';

/**
 * Funktionalität im Modul "Favorite"
 *
 * @module favorite
 */

export const opaccFavoritePlugin = new OpaccFavorite();